import gql from 'graphql-tag';

export default gql`
  query GetPost($id: ID!) {
    post(id: $id) {
      createdAt
      id
      updatedAt
      title
      body
      status
      type
      category
      pdfs
      roles
      image {
        id
        scaled
        original
        thumbnail
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetPost.ts